import { forwardRef } from 'react';
import { CircularProgress } from '@mui/material';
import { useInterstateTheme } from '../InterstateThemeProvider';
import { idBuilder } from '../internal';
import { spinnerStyleBuilder } from './spinnerStyleBuilder';
import { jsx as _jsx } from "react/jsx-runtime";
export const Spinner = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    id,
    size,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsx(CircularProgress, {
    size: size,
    id: idBuilder('ids-spinner-root', id),
    "data-testid": idBuilder('ids-spinner-root', rest['data-testid']),
    thickness: 4.4,
    sx: spinnerStyleBuilder(theme)
  });
});
Spinner.displayName = 'Spinner';